'use strict';

const { h } = require('phy');

const CouponCardAction = require('./coupon-card-action');
const OfferExpiry = require('../../shared/views/offer/offer-expiry');
const OfferViewTerms = require('../../shared/views/offer/offer-view-terms');

function Legal({ item, isCard = false }) {
  const elements = [
    OfferExpiry({
      className: 'coupon-card-expiry',
      expires: item.offerExpiry,
    }),
  ];

  if (item.offerId) {
    elements.push(
      OfferViewTerms({
        offerId: item.offerId,
        className: 'coupon-card-terms',
      })
    );
  }

  if (isCard) {
    elements.push(
      CouponCardAction({
        offerId: item.offerId,
        offerType: item.offerType,
      })
    );
  }

  return h('.legal', elements);
}

module.exports = Legal;
